/*
 * ---------------------------------------------------------------------
 * import modules
 * ---------------------------------------------------------------------
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import {
    Button,
    Tooltip,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@material-ui/core";

import Icon from "@material-ui/core/Icon";

import {
    t
} from "src/shared_modules/i18n";

import {
    openChat,
    closeChat,
} from "src/shared_modules/veu-visitors-plazz/actions/chat"

import {
    hideAllPopovers,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    hideContent
} from "src/shared_modules/veu-visitors-core/actions/content";

import {
    hidePageGlobal
} from "src/shared_modules/veu-visitors-core/actions/pages";

import './visitor-button.css';

/*
 * ---------------------------------------------------------------------
 * class VisitorButton
 * ---------------------------------------------------------------------
 */
class VisitorButton extends React.Component {

    componentDidMount() {
        this.clickVisitors = this.clickVisitors.bind(this);
    }

    clickVisitors() {
        let enablePlazzChat = this.props.event.hasPlazzConvention
                && this.props.event.hasPlazzChat
                && this.props.user.loggedIn
                && this.props.user.plazz
                && this.props.user.plazz.privacy.person_chat;

        if( !enablePlazzChat )
            return;

        if( (this.props.plazzchat.isOpen && this.props.plazzchat.activeTab !== "persons")
                || !this.props.plazzchat.isOpen
            ) {
            this.props.hideContent();
            this.props.hidePageGlobal();
            this.props.hideAllPopovers();
            this.props.openChat("persons");
        } else {
            this.props.closeChat();
        }

        if( this.props.mobile && this.props.onClick )
            this.props.onClick();
    }

    renderMobile() {
        // TODO  restricted events let evIsPublic = (this.props.event.accesslevel === "public");
        let enablePlazzChat = this.props.event.hasPlazzConvention
                && this.props.event.hasPlazzChat
                && this.props.user.loggedIn
                && this.props.user.plazz;

        let countglobal = this.props.community.countglobal;
        let countroom = this.props.community.countroom;

        let cssVistorIcon = "visitor-icon";

        let icon = {
            backgroundImage: `url("${process.env.PUBLIC_URL}/assets/icon-userlist.png")`
        }
        if( this.props.plazzchat.isOpen && this.props.plazzchat.activeTab === "persons"  )
        {
            // TODO
        }

        return (<React.Fragment>
                    <ListItem color="primary" button disabled={!enablePlazzChat} onClick={() => this.clickVisitors()} >
                        <ListItemIcon><Icon className={cssVistorIcon} style={icon}/></ListItemIcon>
                        <ListItemText primary={
                            <span className="visitor-counter">
                                    <span>{countroom} &nbsp;</span>
                                    /
                                    <span>&nbsp; {countglobal}</span>
                            </span>
                        } />
                    </ListItem>
            </React.Fragment>);
    }

    renderDesktop() {
        // TODO  restricted events let evIsPublic = (this.props.event.accesslevel === "public");
        let enablePlazzChat = this.props.event.hasPlazzConvention
                && this.props.event.hasPlazzChat
                && this.props.user.loggedIn
                && this.props.user.plazz;

        let countglobal = this.props.community.countglobal;
        let countroom = this.props.community.countroom;

        let cssVistorIcon = "visitor-icon";
        let icon = {
            backgroundImage: `url("${process.env.PUBLIC_URL}/assets/icon-userlist.png")`
        }
        if( this.props.plazzchat.isOpen && this.props.plazzchat.activeTab === "persons"  )
        {
            // TODO
        }
        return (<React.Fragment>
                    <Button color="primary"
                            fullWidth={Boolean(this.props.mobile)}
                            disabled={!enablePlazzChat}
                            startIcon={ <Icon className={cssVistorIcon} style={icon} /> }
                            onClick={() => this.clickVisitors()}
                    >
                        <span className="visitor-counter">
                            <Tooltip title={t("main-nav.visitors-room")} >
                                <span>&nbsp; {countroom} &nbsp;</span>
                            </Tooltip>
                                /
                            <Tooltip title={t("main-nav.visitors-all")} >
                                <span>&nbsp; {countglobal} &nbsp;</span>
                            </Tooltip>
                        </span>
                    </Button>
            </React.Fragment>);
    }

    render() {
        let { pathname } = this.props.location;

        // if user is on home he has no access to event for any reason so there is no visitor indicator!!!!
        if( pathname.endsWith("home") || pathname.endsWith("preregister") )
            return(null);

        let isPublic = (this.props.event.accesslevel === "public");
        let showVisitors = this.props.event.onAir && ( this.props.user.loggedIn || isPublic );

        if( !showVisitors )
            return(null);

        return (<React.Fragment>
                { this.props.mobile && this.renderMobile() }
                { !this.props.mobile && this.renderDesktop() }
            </React.Fragment>);
    }

}
/*
 * ---------------------------------------------------------------------
 * VisitorButton prop Types
 * ---------------------------------------------------------------------
 */
VisitorButton.propTypes = {
    user : PropTypes.object,
    community : PropTypes.object,
    event : PropTypes.object,
    plazzchat: PropTypes.object,
};
/*
 * ---------------------------------------------------------------------
 * VisitorButton Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        user : state.user,
        community : state.system.community,
        event : state.event,

        plazzchat: state.plazz.chat,
    };
};

const mapDispatchToProps = {
    openChat,
    closeChat,
    hideAllPopovers,
    hideContent,
    hidePageGlobal
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(withRouter(VisitorButton));
